<div id="pending-users-page" class="body-padding">
  <div class="flex flex-col items-baseline mb-4">
    <h1 id="pending-users-title" class="general-font text-4xl font-bold text-gray-900">Pending Users</h1>
  </div>
  <div class="flex flex-wrap gap-4 items-baseline align-baseline">
    <div class="w-fit mr-3 ">
      <label for="pending-users-search-input" class="block mb-2 text-sm font-medium text-gray-900">Search</label>
      <div id="pending-users-search-container"
           class="flex items-center h-fit border border-gray-300 rounded-lg w-fit bg-gray-50">
        <svg class="ml-2 h-5 w-5 pr-1 text-gray-600" width="15" height="16" viewBox="0 0 15 16" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <g id="Left Icon">
            <path id="Vector"
                  d="M14.5 15L10.5 11M6.5 13C3.18629 13 0.5 10.3137 0.5 7C0.5 3.68629 3.18629 1 6.5 1C9.81371 1 12.5 3.68629 12.5 7C12.5 10.3137 9.81371 13 6.5 13Z"
                  stroke="#1D1929"/>
          </g>
        </svg>
        <input id="pending-users-search-input" [(ngModel)]="search" (change)="refreshData()" type="text"
               placeholder="Pending Users Lookup" class="input-custom"/>
      </div>
    </div>
  </div>
  <div id="pending-users-table-container" class="mt-8">
    <custom-table id="pending-users-table" [columns]="tableColumns" [data]="tableData" [actions]="tableActions"
                  primaryDataKey="cp_pending_user_id" [serverPagination]="true" [loading]="loadingTableData()"
                  (paramsChange)="onTableParamChange($event)" emptyDataMessage="No Users matching your filters"/>
  </div>
</div>

<ng-template #approveIcon let-row>
  <svg class="w-4 h-4 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="m5 12 4.7 4.5 9.3-9"/>
  </svg>
</ng-template>
<ng-template #rejectIcon let-row>
  <svg class="w-4 h-4 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M6 18 18 6m0 12L6 6"/>
  </svg>
</ng-template>

@if (approvingUserId) {
  <pending-user-approve-modal (approve)="approveUser($event.roleId, $event.locationIds)"
                              (close)="cancelUserApproving()"/>
}
